<template>
	
	<CommonLoading
		v-if="loading"
	/>
	<FilterComponent
		:title="'Rotas'"
		:open="openFilter"
		:fields="filterFields"
		:activeFilters= "filters"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
	/>
	<CommonListing
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:inputsListing= "inputs"
		:previous = "previous"
		:next = "next"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:resetFormData= "resetFormData"
		:editFormData= "editFormData"
		:importFile= "false"
		:useForms= "false"
		:fileOnly="false"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@delete-data-id= "deleteData"
		@edit-alternative= "getEditData"
		@view-alternative= "viewData"
		@filter="openFilter = true"
	/>
	<ListaDeAgendamentosForm
		:open= "editingOpen"
		:inputsList="inputs"
		:placeHolderValues= "editFormData"
		:consultores="consultores"
		@editing-data= "onSendEditingData"
		@update-open= "editingOpen = false"
		@segurado-badge="seguradoBadge"
		@remove-badge="deleteBadge"
		@empresa-lista="getEditData"
		@desvincular-empresa="deleteEmpresa"
	/>
	<ListaDeAgendamentosCommonView
		:title="'Dados de Agendamento'"
		:open= "viewOpen"
		:data= "listaData"
		@update-open= "viewOpen = false"
	/>

</template>
<script>

import { pageVariables } from '@/views/insideviews/listas_de_agendamentos/PageVariablesListaDeAgendamentos';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import ListaDeAgendamentosRepository from '@/services/ListaDeAgendamentosRepository.vue';
import ListaDeAgendamentosForm from './ListaDeAgendamentosForm.vue';
import ListaDeAgendamentosCommonView from './ListaDeAgendamentosCommonView.vue';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import CommonLoading from '@/components/generalcomponents/CommonLoading';
import Swal from "sweetalert2";
import GruposRepository from '@/services/GruposRepository.vue';
import CommonListing from '@/components/generalcomponents/CommonListing.vue';
import BadgesRepository from '@/services/BadgesRepository.vue';

export default {
	name: 'ListaDeAgendamentosView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		await this.validarFiltroPorGrupo();
		await this.$nextTick(); // Garante que tudo do data está pronto
		this.pageData(this.getPageLista);
		
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			loading : false, 
			resetFormData: false,
			editFormData:{},
			editingOpen: false,
			viewOpen: false,
			listaData:{},
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			openFilter: false,
			filters: {},
			actualPage: '',
			editingListaId: '',
			filterFields: [
				{
					name: "consultor_email",
					label: "Consultor",
					type: "input",
					placeholder: "Digite o email do consultor"
				},
				{
					name: "endereco",
					label: "Endereço",
					type: "input",
					placeholder: "Digite o endereço"
				},
				{
					name: "data_agendamento",
					label: "Data de Contato",
					type: "date",
					placeholder: "Selecione a data de contato"
				},
				{
					name: "data_retorno",
					label: "Data de Retorno",
					type: "date",
					placeholder: "Selecione a data de retorno"
				},
				{
					name: "data_visita",
					label: "Data de Visita",
					type: "date",
					placeholder: "Selecione a data de visita"
				},
				{
					name: "status",
					label: "Status",
					type: "input",
					placeholder: "Digite o status"
				},
				{
					name: "status_contato",
					label: "Status do Atendimento",
					type: "input",
					placeholder: "Digite o status do atendimento"
				},
				{
					name: "nome",
					label: "Nome",
					type: "input",
					placeholder: "Digite o nome do segurado ou dependente"
				},
				{
					name: "carreira",
					label: "Carreira",
					type: "input",
					placeholder: "Digite a Profissão do segurado ou dependente"
				},
				{
					name: "idade",
					label: "Idade",
					type: "input",
					placeholder: "Digite a idade do segurado ou dependente"
				},
				{
					name: "agendamento",
					label: "Agendamento",
					type: "input",
					placeholder: "Digite o nome do agendamento"
				}
			]
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			this.actualPage = page;
			this.loading = true; 
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.getListas(page,this.onlineUser.token,this.filters);
				if (response?.status  === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;
					this.getConsultores()
				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {

					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},
		async onSendFormData(data){
			this.loading = true; 
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.createLista(this.page,data,this.onlineUser.token);
				if (response?.status === 201) {
					this.pageData(this.actualPage);
					this.resetForm();
					this.mostrarAlerta();
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async onSendEditingData(data, id) {
			console.log(data)
			console.log(id)
			this.loading = true; 
			this.loading = true; 
			const listaRepo = new ListaDeAgendamentosRepository();

			try {
				const response = await listaRepo.updateLista(this.page, this.onlineUser.token, id, data);
				if (response?.status === 200) {
					this.editingOpen = false;
					this.pageData(this.actualPage);
					this.mostrarAlerta();
					this.loading = false; 
				} else {
					this.loading = false; 
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},
		async deleteData(id){
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.deleteLista(this.page,this.onlineUser.token,id);
				if (response?.status === 204) {
					this.pageData(this.actualPage);
					this.mostrarAlerta();

				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async getEditData(id){
			this.editingListaId = id;
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.getLista(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					this.editFormData = response.data.agendamento
					this.editingOpen =true
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async viewData(id){
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.getLista(this.listaViewPage,this.onlineUser.token,id);
				if (response?.status === 200) {
					this.listaData = response.data
					this.viewOpen = true
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async getConsultores(){
			const groupsRepo = new GruposRepository();
			try {
				const response = await groupsRepo.getGroupMembers(this.onlineUser.token,this.consultoresPage);
				if (response?.status === 200) {
					this.consultores = response.data
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},

		async validarFiltroPorGrupo() {

			const grupos = this.onlineUser?.user?.groups || [];
			const params = new URLSearchParams(window.location.search);
			const idLista = params.get('id');
			
			// Se o usuário estiver no grupo master.justech, não aplica o filtro
			if (grupos.includes('master.justech')) return;

			const pertenceGrupoLimitado = grupos.includes('consultores') || grupos.includes('agendadores');

			if (!pertenceGrupoLimitado) return;

			if (idLista) {
				this.filters.lista_de_agendamento_id = idLista;
			}

			const index = this.filterFields.findIndex(f => f.name === 'agendamento');
			if (index !== -1) {
				this.filterFields.splice(index, 1);
			}

		},
		
		goTo(number){
			this.pageData(this.getPageLista+"?page="+number)
		},
		handleFilters(rawFilters) {
			const params = new URLSearchParams(window.location.search);
			const idLista = params.get('id');

			// Garante que o filtro de lista esteja presente se tiver ID na URL
			if (idLista && !rawFilters.lista_de_agendamento_id) {
				rawFilters.lista_de_agendamento_id = idLista;
			}

			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.getPageLista);
		},
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		},
		dayFilter(dateFilter){
			this.filters = { ...this.filters, data_visita: dateFilter };
			this.pageData(this.getPageLista);
		},

		async seguradoBadge(badge){
			this.loading = true;
			const badgeRepo = new BadgesRepository();
			try {
				const response = await badgeRepo.createBadge(this.pageBadge,badge,this.onlineUser.token);
				
				if (response?.status === 201) {
					this.getEditData(this.editingListaId);
					this.mostrarAlerta();
					this.loading = false;
				} else {
					this.error = response?.message;
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}	

		},

		async deleteBadge(id){
			const badgeRepo = new BadgesRepository();
			try {
				const response = await badgeRepo.deleteBadge(this.pageBadge,this.onlineUser.token,id);
				
				if (response?.status === 200) {
					this.getEditData(this.editingListaId);
					this.mostrarAlerta();
					this.loading = false;
				} else {
					this.error = response?.message;
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}	
		},

		async deleteEmpresa(id){
			const listaRepo = new ListaDeAgendamentosRepository();
			try {
				const response = await listaRepo.desvincularEmpresaLista(id,this.onlineUser.token);
				
				if (response?.status === 200) {
					this.getEditData(this.editingListaId);
					this.mostrarAlerta();
					this.loading = false;
				} else {
					this.error = response?.message;
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}	
		},

		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6',
			});
		},
		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message,
				confirmButtonColor: '#3085d6', 
			});
		},
	},
	components:{
		ListaDeAgendamentosForm,
		ListaDeAgendamentosCommonView,
		FilterComponent,
		//ListaDeAgendamentosCalendar,
		CommonLoading,
		CommonListing
	},
	setup() {
	return {
	}
	}}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
